import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'

import { useCurrentCompany } from '@/lib/useCompany'

// 경로 → 메뉴명. 더 구체적인 경로를 먼저(최장 접두 매칭). '/main'(발주서 변환 인덱스)은 맨 뒤.
const ROUTE_TITLES: Array<[string, string]> = [
  ['/main/quote',       '견적서 변환'],
  ['/main/verify',      '저장 검증'],
  ['/main/partners',    '거래처관리'],
  ['/main/items',       '품목관리'],
  ['/main/prices',      '거래처별 단가'],
  ['/main/delivery',    '출고처리'],
  ['/main/receiving',   '입고처리'],
  ['/main/collections', '수금등록'],
  ['/main/payments',    '지급등록'],
  ['/main/ledger',      '채권채무집계'],
  ['/main/code-match',  '발주서 변환'],
  ['/main/dept-match',  '발주서 변환'],
  ['/invoice-print',    '거래명세서 인쇄'],
  ['/company-select',   '회사 선택'],
  ['/login',            '로그인'],
  ['/main',             '발주서 변환'],
]

function labelFor(pathname: string): string {
  for (const [path, label] of ROUTE_TITLES) {
    if (pathname === path || pathname.startsWith(path + '/')) return label
  }
  return '그린푸드 ERP'
}

/** 브라우저 탭 제목을 "메뉴명 - 회사명" 으로 동기화. 메뉴별로 창을 여러 개 띄워도 탭이 구분됨. */
export function TitleSync() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  // 회사관리 화면 탭 창(?tab=일일매출 등) — 창 제목을 탭 이름으로.
  const tab = useRouterState({ select: (s) => (s.location.search as Record<string, unknown>).tab })
  const companyName = useCurrentCompany()?.name

  useEffect(() => {
    const label = pathname === '/company-select' && typeof tab === 'string' && tab && tab !== '회사'
      ? tab : labelFor(pathname)
    document.title = companyName ? `${label} - ${companyName}` : label
  }, [pathname, companyName, tab])

  return null
}
